<template>
    <div>
        <b-modal size="lg" id="bv-modal-process-settlement" hide-footer :title="'Process settlement for '+employee_name">
                        {{onAmountChange}}

                    <b-overlay  :show="showoverlaymodal" class='showoverlay_settle' rounded="sm">
                        <!-- <div class="d-flex"> -->
                        <div class="d-block">

                            <b-form @submit.stop.prevent="deregistrationSubmit" class="settlement-form">
                                <div class="clearfix">
                                    <div class="row clearfix">
                                    <div class="col-md-12 float-left">

                                        <div class="d-flex" style="font-size: 13px;">
                                            <div class='text-left mb-4 col-md-6' >
                                                <span v-if="form_status !=0"><span style="color: #004242; font-weight: 500;">Settlement ID: </span></span>
                                            </div>

                                            <div class='text-right mb-4 col-md-6'>
                                                <!-- <a href="#" class="px-3 py-1 border rounded" style="border:1px solid green !important; color: green;" >
                                                    <i class="far fa-file-excel mr-1"></i>
                                                    Download Schedule
                                                </a> -->
                                                <div class='text-right mb-3' @click="getEmployeePfReport(employee_id)"><a href="#" class="px-3 py-1 border rounded" style="border:1px solid green !important; color: green;" ><i class="far fa-file-excel mr-1"></i> Download Schedule</a></div>
                                                <span class="px-3 py-1 rounded ml-2" v-if="form_status==1" style="background: #00c177; color: #ffffff;">
                                                    Approved
                                                </span>
                                                <span class="px-3 py-1 rounded ml-2" v-if="form_status==2" style="background: #00c177; color: #ffffff;">
                                                    Approved
                                                </span>
                                                <span class="px-3 py-1 rounded ml-2" v-if="form_status==3" style="background: #e8b80f; color: #ffffff;">
                                                    Deferred
                                                </span>
                                                <span class="px-3 py-1 rounded ml-2" v-if="form_status==4" style="background: #e8b80f; color: #ffffff;">
                                                    Awaiting Consent
                                                </span>
                                                <span class="px-3 py-1 rounded ml-2" v-if="form_status==5" style="background: #e8b80f; color: #ffffff;">
                                                    Applied: Level 2
                                                </span>
                                            </div>
                                        </div>


                                        <div class="d-flex" style="font-size: 13px;">
                                            <div class="col-md-6 pr-0">
                                                <b-form-group id="settlement_date-group" label="Settlement Application Date" label-for="settlement_date" class="required-field">
                                                    <b-input-group class="mb-3">
                                                        <b-form-input id="settlement_date"   :state="validateState('settlement_date')" name="settlement_date" v-model="settlement_fdata.settlement_date"  type="text" placeholder="YYYY-MM-DD" autocomplete="off" v-validate="{required:true,date_format:'yyyy-MM-dd' }"  aria-describedby="settlement_date-feedback" data-vv-as="Date"></b-form-input>
                                                        <template v-if="settlement_fdata.settlement_status != 'Disbursed'">
                                                                <b-form-datepicker id="settlement_date" button-only right locale="en-US" v-model="settlement_fdata.settlement_date" :min="date_min" ></b-form-datepicker>
                                                        </template>
                                                        <b-form-invalid-feedback id="settlement_date-feedback">{{ veeErrors.first('settlement_date') }}</b-form-invalid-feedback>
                                                    </b-input-group>
                                                </b-form-group>
                                                <b-form-group  id="settlement-type-group" label="Type of Settlement" class="required-field" label-for="settlement_type ">
                                                    <b-form-select
                                                        id="settlement_type" name="settlement_type" data-vv-as="Type" :state="validateState('settlement_type')" v-model="settlement_fdata.settlement_type"
                                                        :options="settlementOptions" v-validate="{ required: true }">
                                                        </b-form-select>
                                                        <b-form-invalid-feedback id="settlement_type-feedback">{{ veeErrors.first('settlement_type') }}</b-form-invalid-feedback>
                                                </b-form-group>

                                                <template v-if="settlement_id > 0">
                                                    <b-form-group id="settlement_status-group" label="Status" label-for="settlement_status">
                                                    <b-input-group class="mb-3">
                                                        <b-form-input id="settlement_status" :disabled="disabled"  name="settlement_status" v-model="settlement_fdata.settlement_status"  type="text" autocomplete="off"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </template>

                                                <b-form-group  id="settlement-reason-group" label="Reason for Settlement" class="required-field"    label-for="settlement_reason ">
                                                    <b-form-select
                                                        id="settlement_reason" name="settlement_reason" data-vv-as="Type" :state="validateState('settlement_reason')"
                                                        :options="settlementReasonOptions" v-model="settlementreason" v-validate="{ required: true }" @change="getSettlementSlabWiseData()">
                                                        </b-form-select>
                                                        <b-form-invalid-feedback id="settlement_reason-feedback">{{ veeErrors.first('settlement_reason') }}</b-form-invalid-feedback>
                                                </b-form-group>
                                                <b-form-group   label="Attachments" label-for="upload_file">
                                                    <b-form-file id="upload_file" ref="upload_file" v-model="upload_file" accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx" @change="fieldChange" placeholder="Attach File" multiple  :file-name-formatter="formatNames" ><i class="fa-solid fa-paperclip"></i></b-form-file>
                                                </b-form-group>
                                            </div>

                                            <pf-settlement-employee-details :pageurl="pageurl" :employee_pf_data="employee_pf_data"></pf-settlement-employee-details>
                                        </div>



                                        <div class="card-body">
                                            <div class="employee-table-wrapper">

                                                <table class="employee-list-table dataTable table-overflow table-sticky">

                                                <thead>
                                                <tr class="table-head">
                                                    <td class="text-center">
                                                        Particulars
                                                    </td>
                                                    <td class="text-center">
                                                        Balance
                                                    </td>
                                                    <td class="text-center">
                                                    Settlement Amount *
                                                    </td>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr  class="hover-bg table-row">
                                                    <td class="text-left">
                                                        Employer’s contribution to PF
                                                    </td>
                                                    <td class="text-right">
                                                        {{formatMoney(employee_pf_data.pf_contribution_company)}}
                                                    </td>
                                                    <td class="text-right">
                                                        <b-form-group id="salary_contribution_employer-group"  class="required-field settlement_field_trz" label-for="salary_contribution_employer">
                                                        <!-- <b-form-input id="salary_contribution_employer" :state="validateState('salary_contribution_employer')" :disabled="disable_amount" name="salary_contribution_employer" v-model="settlement_fdata.salary_contribution_employer" v-validate="{ required: true,numeric:true,max_value:Math.ceil(employee_pf_data.pf_contribution_company)}" aria-describedby="salary_contribution_employer-feedback" data-vv-as=" Employer’s contribution to PF " ></b-form-input> -->
                                                        <b-form-input id="salary_contribution_employer" :state="validateState('salary_contribution_employer')" :disabled="disable_amount" name="salary_contribution_employer" v-model="settlement_fdata.salary_contribution_employer" v-validate="{ required: true, decimal:2, max_value:Math.ceil(employee_pf_data.pf_contribution_company)}" aria-describedby="salary_contribution_employer-feedback" data-vv-as=" Employer’s contribution to PF " class="position-relative"></b-form-input>
                                                        <!-- Rejwan: 16-02-2025 -->
                                                        <!-- <b-form-invalid-feedback id="salary_contribution_employer-feedback">{{ veeErrors.first('salary_contribution_employer') }}</b-form-invalid-feedback> -->
                                                        <b-form-invalid-feedback id="salary_contribution_employer-feedback" class="error-message">{{ veeErrors.first('salary_contribution_employer') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </td>
                                                </tr>
                                                <tr  class="hover-bg table-row">
                                                    <td class="text-left">
                                                        Employee’s contribution to PF
                                                    </td>
                                                    <td class="text-right">
                                                        {{formatMoney(employee_pf_data.pf_contribution_employee)}}
                                                    </td>
                                                    <td class="text-right">
                                                        <b-form-group id="salary_contribution_employee-group"  class="required-field settlement_field_trz" label-for="salary_contribution_employee">
                                                        <!-- <b-form-input id="salary_contribution_employee" :state="validateState('salary_contribution_employee')" :disabled="disable_amount" name="salary_contribution_employee" v-model="settlement_fdata.salary_contribution_employee" v-validate="{ required: true,numeric:true,max_value:Math.ceil(employee_pf_data.pf_contribution_employee)}" aria-describedby="salary_contribution_employee-feedback" data-vv-as=" Employee’s contribution to PF " ></b-form-input> -->
                                                        <b-form-input class="position-relative" id="salary_contribution_employee" :state="validateState('salary_contribution_employee')" :disabled="disable_amount" name="salary_contribution_employee" v-model="settlement_fdata.salary_contribution_employee" v-validate="{ required: true, decimal:2, max_value:Math.ceil(employee_pf_data.pf_contribution_employee)}" aria-describedby="salary_contribution_employee-feedback" data-vv-as=" Employee’s contribution to PF " ></b-form-input>
                                                        <!-- Rejwan: 16-02-2025 -->
                                                        <!-- <b-form-invalid-feedback id="salary_contribution_employee-feedback">{{ veeErrors.first('salary_contribution_employee') }}</b-form-invalid-feedback>
                                                        </b-form-group> -->
                                                        <b-form-invalid-feedback id="salary_contribution_employee-feedback" class="error-message">{{ veeErrors.first('salary_contribution_employee') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </td>
                                                </tr>
                                                <tr  class="hover-bg table-row">
                                                    <td class="text-left">
                                                        Profit balance on employer’s contribution
                                                    </td>
                                                    <td class="text-right">
                                                        {{formatMoney(employee_pf_data.pf_profit_company)}}
                                                    </td>
                                                    <td class="text-right">

                                                        <b-form-group id="profit_contribution_employer-group" class="required-field settlement_field_trz" label-for="profit_contribution_employer">
                                                        <!-- <b-form-input id="profit_contribution_employer" :state="validateState('profit_contribution_employer')" :disabled="disable_amount" name="profit_contribution_employer" v-model="settlement_fdata.profit_contribution_employer" v-validate="{ required: true,numeric:true,max_value:Math.ceil(employee_pf_data.pf_profit_company)}" aria-describedby="profit_contribution_employer-feedback" data-vv-as=" Profit balance on employer’s contribution " ></b-form-input> -->
                                                        <b-form-input class="position-relative" id="profit_contribution_employer" :state="validateState('profit_contribution_employer')" :disabled="disable_amount" name="profit_contribution_employer" v-model="settlement_fdata.profit_contribution_employer" v-validate="{ required: true, decimal:2, max_value:Math.ceil(employee_pf_data.pf_profit_company)}" aria-describedby="profit_contribution_employer-feedback" data-vv-as=" Profit balance on employer’s contribution " ></b-form-input>
                                                         <!-- Rejwan: 16-02-2025 -->
                                                        <!-- <b-form-invalid-feedback id="profit_contribution_employer-feedback">{{ veeErrors.first('profit_contribution_employer') }}</b-form-invalid-feedback>
                                                        </b-form-group> -->
                                                        <b-form-invalid-feedback id="profit_contribution_employer-feedback" class="error-message">{{ veeErrors.first('profit_contribution_employer') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </td>
                                                </tr>
                                                <tr  class="hover-bg table-row">
                                                    <td class="text-left">
                                                        Profit balance on employee’s contribution
                                                    </td>
                                                    <td class="text-right">
                                                        {{formatMoney(employee_pf_data.pf_profit_employee)}}
                                                    </td>
                                                    <td class="text-right">
                                                        <b-form-group id="profit_contribution_employee-group" class="required-field settlement_field_trz" label-for="profit_contribution_employee">
                                                        <!-- <b-form-input id="profit_contribution_employee" :state="validateState('profit_contribution_employee')" :disabled="disable_amount" name="profit_contribution_employee" v-model="settlement_fdata.profit_contribution_employee" v-validate="{ required: true,numeric:true,max_value:Math.ceil(employee_pf_data.pf_profit_employee)}" aria-describedby="profit_contribution_employee-feedback" data-vv-as=" Profit balance on employee’s contribution" ></b-form-input> -->
                                                        <b-form-input class="position-relative" id="profit_contribution_employee" :state="validateState('profit_contribution_employee')" :disabled="disable_amount" name="profit_contribution_employee" v-model="settlement_fdata.profit_contribution_employee" v-validate="{ required: true, decimal:2, max_value:Math.ceil(employee_pf_data.pf_profit_employee)}" aria-describedby="profit_contribution_employee-feedback" data-vv-as=" Profit balance on employee’s contribution" ></b-form-input>
                                                        <!-- Rejwan: 16-02-2025 -->
                                                        <!-- <b-form-invalid-feedback id="profit_contribution_employee-feedback">{{ veeErrors.first('profit_contribution_employee') }}</b-form-invalid-feedback>
                                                        </b-form-group> -->
                                                        <b-form-invalid-feedback id="profit_contribution_employee-feedback" class="error-message">{{ veeErrors.first('profit_contribution_employee') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </td>
                                                </tr>
                                                <tr  class="hover-bg table-row">
                                                    <td class="text-left">
                                                        Forfeiture balance on employer’s contribution
                                                    </td>
                                                    <td class="text-right">
                                                        {{formatMoney(employee_pf_data.pf_forfeiture_company)}}
                                                    </td>
                                                    <td class="text-right">

                                                        <b-form-group id="forfeiture_contribution_employer-group" class="required-field settlement_field_trz" label-for="forfeiture_contribution_employer">
                                                        <!-- <b-form-input id="forfeiture_contribution_employer"  :state="validateState('forfeiture_contribution_employer')" :disabled="disable_amount" name="forfeiture_contribution_employer" v-model="settlement_fdata.forfeiture_contribution_employer" v-validate="{ required: true,numeric:true,max_value:Math.ceil(employee_pf_data.pf_forfeiture_company)}" aria-describedby="forfeiture_contribution_employer-feedback" data-vv-as=" Forfeiture balance on employer’s contribution" ></b-form-input> -->
                                                        <b-form-input class="position-relative" id="forfeiture_contribution_employer"  :state="validateState('forfeiture_contribution_employer')" :disabled="disable_amount" name="forfeiture_contribution_employer" v-model="settlement_fdata.forfeiture_contribution_employer" v-validate="{ required: true, decimal:2, max_value:Math.ceil(employee_pf_data.pf_forfeiture_company)}" aria-describedby="forfeiture_contribution_employer-feedback" data-vv-as=" Forfeiture balance on employer’s contribution" ></b-form-input>
                                                        <!-- Rejwan: 16-02-2025 -->
                                                        <!-- <b-form-invalid-feedback id="forfeiture_contribution_employer-feedback">{{ veeErrors.first('forfeiture_contribution_employer') }}</b-form-invalid-feedback> -->
                                                        <b-form-invalid-feedback id="forfeiture_contribution_employer-feedback" class="error-message">{{ veeErrors.first('forfeiture_contribution_employer') }}</b-form-invalid-feedback>
                                                        </b-form-group>

                                                    </td>
                                                </tr>
                                                <tr  class="hover-bg table-row">
                                                    <td class="text-left">
                                                        Forfeiture balance on employee’s contribution
                                                    </td>
                                                    <td class="text-right">
                                                        {{formatMoney(employee_pf_data.pf_forfeiture_employee)}}
                                                    </td>
                                                    <td class="text-right">
                                                    <b-form-group id="forfeiture_contribution_employee-group" class="required-field settlement_field_trz" label-for="forfeiture_contribution_employee">
                                                        <!-- <b-form-input id="forfeiture_contribution_employee"  :state="validateState('forfeiture_contribution_employee')" :disabled="disable_amount" name="forfeiture_contribution_employee" v-model="settlement_fdata.forfeiture_contribution_employee" v-validate="{required: true,numeric:true,max_value:Math.ceil(employee_pf_data.pf_forfeiture_employee)}" aria-describedby="forfeiture_contribution_employee-feedback" data-vv-as=" Forfeiture balance on employee’s contribution" ></b-form-input> -->
                                                        <b-form-input class="position-relative" id="forfeiture_contribution_employee"  :state="validateState('forfeiture_contribution_employee')" :disabled="disable_amount" name="forfeiture_contribution_employee" v-model="settlement_fdata.forfeiture_contribution_employee" v-validate="{required: true, decimal:2, max_value:Math.ceil(employee_pf_data.pf_forfeiture_employee)}" aria-describedby="forfeiture_contribution_employee-feedback" data-vv-as=" Forfeiture balance on employee’s contribution" ></b-form-input>
                                                        <!-- Rejwan: 16-02-2025 -->
                                                        <!-- <b-form-invalid-feedback id="forfeiture_contribution_employee-feedback">{{ veeErrors.first('forfeiture_contribution_employee') }}</b-form-invalid-feedback> -->
                                                        <b-form-invalid-feedback id="forfeiture_contribution_employee-feedback" class="error-message">{{ veeErrors.first('forfeiture_contribution_employee') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </td>
                                                </tr>

                                                <tr  class="hover-bg table-row">
                                                    <td class="text-left">
                                                        Outstanding Advance Balance
                                                    </td>
                                                    <td class="text-right">
                                                        ({{formatMoney(employee_pf_data.loan_adjustable)}})
                                                    </td>
                                                    <td class="text-right">
                                                        ({{formatMoney(employee_pf_data.loan_adjustable)}})
                                                    </td>
                                                </tr>
                                                <tr  class="hover-bg table-row">
                                                    <td class="text-left">
                                                        Outstanding Service Charge
                                                    </td>
                                                    <td class="text-right">
                                                        ({{formatMoney(employee_pf_data.service_charge_payable)}})
                                                    </td>
                                                    <td class="text-right">
                                                        ({{formatMoney(employee_pf_data.service_charge_payable)}})
                                                    </td>
                                                </tr>

                                                <!-- //  -->
                                                <tr class="hover-bg table-row mx-2" v-for="(row, index) in adjustment_entries">


                                                    <td class="text-left pl-2 pr-2">
                                                            <span v-on:click="removeElement(index);" class="border rounded px-3 py-2"><b-icon class="delete-btn-red" icon="trash-fill" role="button" aria-hidden="true" scale="1.2" ></b-icon></span>
                                                            <b-form-select
                                                                v-model="row.adjustment_id"
                                                                :options="settlementDamageOptions" style="width: 85%;" >
                                                            </b-form-select>
                                                    </td>
                                                    <td class="text-right">
                                                        Less
                                                    </td>
                                                    <td class="text-right">
                                                        <b-form-group  class="required-field settlement_field_trz" >
                                                            <b-form-input v-model="row.value" ></b-form-input>
                                                        </b-form-group>
                                                    </td>
                                                </tr>

                                                <!-- //  -->

                                                <tr class="hover-bg table-row" style="background: #cbe7e4 !important;">
                                                    <td class="text-left">
                                                        Net Payable
                                                    </td>
                                                    <td class="text-right">
                                                        <!-- Start: Rejwan: 23-06-2026 -->
                                                        <!-- {{formatMoney(employee_pf_data.closing_balance)}} -->
                                                        <!-- {{ formatMoney(employee_pf_data.pf_net_payable_amount) }} -->
                                                          {{ formatMoney(displayNetPayable) }}
                                                        <!-- End: Rejwan: 23-06-2026 -->
                                                    </td>
                                                    <td class="text-right">
                                                        {{formatMoney(settlement_amount)}}
                                                    </td>
                                                </tr>
                                                </tbody>
                                                </table>
                                                <!-- <div class="trz-feedback mt-4 " style="display:flex !important;" > --> <!-- Rejwan: 04-06-2025 Pf Settlement -->
                                                <div class="trz-feedback mt-4 " style="display:flex !important;" v-if="is_balance_adjustment"> <!-- Rejwan: 04-06-2025 Pf Settlement -->
                                                    <div class="col-md-4 pl-0 pr-0"><b-button class="border rounded bg-light py-1 px-5" @click="addRow" variant="primary">Add Balance Adjustment</b-button></div>
                                                    <div class="col-md-8 pl-2 pr-0">* Please enter the settlement amount based on the balance available and in accordance with your trust deed.</div>
                                                </div>
                                                <div class="d-flex">
                                                    <div class="col-md-4 pl-0 pr-0"></div>
                                                    <div class="col-md-8 pl-2 pr-0 mt-3">
                                                        <div class="trz-invalid-feedback" style="display:block !important;" v-if="this.pf_from_disable==true" >* {{settlement_disable_msg}}</div> <!-- Mustafijur: 16-07-2026: added * -->
                                                    </div>
                                                </div>

                                                <b-form-group  id="settlement_details-group" label="Remarks" class="required-field" label-for="settlement_details">
                                                    <b-form-textarea id="settlement_details" :disabled="disable_amount" :state="validateState('settlement_details')" name="settlement_details" v-model="settlement_fdata.settlement_details" v-validate="{ required: true }" rows="3" max-rows="6"  no-resize   aria-describedby="settlement_details-feedback" data-vv-as="Remarks"></b-form-textarea>
                                                    <b-form-invalid-feedback id="settlement_details-feedback">{{ veeErrors.first('settlement_details') }}</b-form-invalid-feedback>
                                                </b-form-group>

                                                <template v-if="settlement_fdata.settlement_type == 0 && settlementreason > 0 && employee_pf_data.waived_profit > 0">

                                                    <table class="employee-list-table dataTable table-overflow table-sticky pt-4">

                                                        <thead>
                                                        <tr class="table-head">
                                                            <td colspan="3">Adjustment of Waived Profit as per Settlement Policy</td>
                                                        </tr>
                                                        <tr class="table-head">
                                                            <td class="text-center">
                                                                Component
                                                            </td>
                                                            <td class="text-center">
                                                                Balance
                                                            </td>
                                                            <td class="text-center">
                                                                Amount *
                                                            </td>
                                                        </tr>
                                                        </thead>
                                                        <tbody>

                                                            <tr  class="hover-bg table-row">
                                                                <td class="text-left">
                                                                    Waived Profit: Employer
                                                                </td>
                                                                <td class="text-right">
                                                                    {{formatMoney(employee_pf_data.waived_profit_employer)}}
                                                                </td>
                                                                <td class="text-right">

                                                                    <b-form-group id="profit_contribution_employer_waived-group" class="required-field settlement_field_trz" label-for="profit_contribution_employer_waived">
                                                                    <b-form-input id="profit_contribution_employer_waived" :state="validateState('profit_contribution_employer_waived')" :disabled="disable_amount" name="profit_contribution_employer_waived" v-model="settlement_fdata.profit_contribution_employer_waived" v-validate="{ required: true,numeric:true,max_value:Math.ceil(employee_pf_data.waived_profit_employer)}" aria-describedby="profit_contribution_employer_waived-feedback" data-vv-as=" Waived Profit: Employer " ></b-form-input>
                                                                    <b-form-invalid-feedback id="profit_contribution_employer_waived-feedback">{{ veeErrors.first('profit_contribution_employer_waived') }}</b-form-invalid-feedback>
                                                                    </b-form-group>
                                                                </td>
                                                            </tr>


                                                            <tr  class="hover-bg table-row">
                                                                <td class="text-left">
                                                                    Waived Profit: Employee
                                                                </td>
                                                                <td class="text-right">
                                                                    {{formatMoney(employee_pf_data.waived_profit_employee)}}
                                                                </td>
                                                                <td class="text-right">

                                                                    <b-form-group id="profit_contribution_employee_waived-group" class="required-field settlement_field_trz" label-for="profit_contribution_employee_waived">
                                                                    <b-form-input id="profit_contribution_employee_waived" :state="validateState('profit_contribution_employee_waived')" :disabled="disable_amount" name="profit_contribution_employee_waived" v-model="settlement_fdata.profit_contribution_employee_waived" v-validate="{ required: true,numeric:true,max_value:Math.ceil(employee_pf_data.waived_profit_employee)}" aria-describedby="profit_contribution_employee_waived-feedback" data-vv-as=" Waived Profit: Employee " ></b-form-input>
                                                                    <b-form-invalid-feedback id="profit_contribution_employee_waived-feedback">{{ veeErrors.first('profit_contribution_employee_waived') }}</b-form-invalid-feedback>
                                                                    </b-form-group>
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </template>


                                            </div>
                                        </div>

                                        <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 18px;">
                                            <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" :disabled="this.pf_from_disable" type="submit" variant="primary" >Submit</b-button>
                                        </div>
                                    </div>
                                </div>
                                </div>


                            </b-form>
                        </div>
                        <!-- <div class="col-md-3 loan-comments border-left">
                            <h5 class="modal-title">Recent Comments</h5>
                            <discussion-thread :pageurl="pageurl" :ref_id="loan_id"  module="4" :company_id='company_id' :key="thread_key" ></discussion-thread>
                        </div>
                    </div> -->
                    </b-overlay>
        </b-modal>

    </div>
</template>
<script>

    export default{

        mounted() {


        },
        props: ['flg','pageurl','settlement_id','settlement_data','employee_id','employee_name', 'form_status'],
        components: {

        },
        data(){


            return {
                settlement_disable_msg:"Settlement Amount cannot be less than 0 or greater than net payable.",
                settlementOptions: [{text:'Select Settlement Type',value:null},{text:'Final Settlement',value:0}, {text:'Partial Settlement',value:1}],
                showoverlaymodal:false,
                disabled:true,
                auto_filled:true,
                settlement_amount: 0,
                settlement_fdata : {
                  employee_id:0,
                  id: 0,
                  settlement_amount: 0,
                  settlement_date: null,
                  settlement_details:'',
                  settlement_status: null,
                  settlement_type:null,
                  salary_contribution_employer:0,
                  salary_contribution_employee:0,
                  profit_contribution_employer:0,
                  profit_contribution_employee:0,
                  profit_contribution_employer_waived:0,
                  profit_contribution_employee_waived:0,
                  forfeiture_contribution_employer:0,
                  forfeiture_contribution_employee:0,
                  loan_adjustable:0,
                  service_charge_payable:0,
                },
                date_min:'',
                employee_pf_data:{
                    pf_contribution_employee:0,
                    pf_contribution_company:0,
                    pf_profit_employee:0,
                    pf_profit_company:0,
                    pf_forfeiture_employee:0,
                    pf_forfeiture_company:0,
                    loan_adjustable:0,
                    service_charge_payable:0,
                    waived_profit:0,
                    waived_profit_employer:0,
                    waived_profit_employee :0,
                },
                employee_slab_data:[],
                disable_amount:false,
                pf_from_disable:false,
                action_type:0,
                settlementreason : null,
                settlementReasonOptions : [],
                settlementDamageOptions : [],
                percentdata : [],
                adjustment_entries : [],
                upload_file:[],
                is_balance_adjustment: false, // Rejwan: 04-06-2025 Pf Settlement

            }
        },
        methods:{

            // faroque code starts here
           resetForm()
            {
                this.settlement_fdata = {
                  employee_id:0,
                  id: 0,
                  settlement_amount: 0,
                  settlement_date: null,
                  settlement_details:'',
                  settlement_status: null,
                  settlement_type:null,
                  salary_contribution_employer:0,
                  salary_contribution_employee:0,
                  profit_contribution_employer:0,
                  profit_contribution_employee:0,
                  forfeiture_contribution_employer:0,
                  forfeiture_contribution_employee:0,
                  profit_contribution_employer_waived:0,
                  profit_contribution_employee_waived:0,
                  loan_adjustable:0,
                  service_charge_payable:0,
                };
                this.upload_file = [];

            },
            fieldChange(e)
            {
                var handle_return = this.checkFileType(e,'upload_file',['.jpg', '.jpeg', '.png', '.gif', '.pdf','.doc','.docx']);
                if(handle_return == false)
                {
                    return 0;
                }

                let selectedFiles = e.target.files;
                this.upload_file = [];
                if (!selectedFiles.length) {
                    return false;
                }

                for (let i = 0; i < selectedFiles.length; i++) {
                    this.upload_file.push(selectedFiles[i]);
                }
            },
            formatNames(files) {
                return files.length === 1 ? files[0].name : `${files.length} files selected`;
            },
            addRow: function ()
            {
                this.adjustment_entries.push({adjustment_id:null,value:0
                });

                this.tmp++;
            },
            removeElement: function (index) {
                this.adjustment_entries.splice(index, 1);
            },
            getReasons: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                // axios.get(this.$api_url+'/pf/settl-reasons').then(function(response){
                axios.get(this.$api_url+'/pf/settl-reasons',
                {
                    params: {
                        'quick_view': 0
                    }
                    // End: Rejwan: 04-06-2025 Pf Settlement
                } ).then(function(response){

                    // Start: Rejwan: 04-06-2025 Pf Settlement
                    this.is_balance_adjustment = response.data.adjreason.length == 0 ? false : true;
                    // End: Rejwan: 04-06-2025 Pf Settlement
                    this.settlementReasonOptions = [{ value: null, text: "Select Settlement Reason" } ] . concat(response.data.policyreason);
                    this.settlementDamageOptions = [{ value: null, text: "Select Adjustment Reason" } ] . concat(response.data.adjreason);
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },

            getSettlementSlabWiseData : function()
            {
            	let formData = {};

            	formData['settlementreason'] = this.settlementreason;
            	formData['service_period'] = this.employee_pf_data.service_period;
            	formData['membership_period'] = this.employee_pf_data.membership_period;

            	formData['pf_contribution_employee'] = this.employee_pf_data.pf_contribution_employee;
            	formData['pf_contribution_company'] = this.employee_pf_data.pf_contribution_company;

            	formData['pf_profit_company'] = this.employee_pf_data.pf_profit_company;
            	formData['pf_profit_employee'] = this.employee_pf_data.pf_profit_employee;

                formData['pf_profit_company_waived'] = this.employee_pf_data.waived_profit_employer;
            	formData['pf_profit_employee_waived'] = this.employee_pf_data.waived_profit_employee;

            	axios.post(this.$api_url+'/pf/settl-slabdata', formData)
                    .then(function (response)
                    {

                        let percentdata = response.data;

                        // Start: Rejwan: 18-06-2025 Settlement
                        // this.settlement_fdata.salary_contribution_employer = percentdata.employer_contr;
                        // this.settlement_fdata.salary_contribution_employee = percentdata.employee_contr;
                        // this.settlement_fdata.profit_contribution_employer = percentdata.employer_profit;
                        // this.settlement_fdata.profit_contribution_employee = percentdata.employee_profit;
                        // this.settlement_fdata.profit_contribution_employee_waived = percentdata.employee_profit_waived;
                        // this.settlement_fdata.profit_contribution_employer_waived = percentdata.employer_profit_waived;

                        this.settlement_fdata.salary_contribution_employer = this.roundProfift(percentdata.employer_contr);
                        this.settlement_fdata.salary_contribution_employee = this.roundProfift(percentdata.employee_contr);
                        this.settlement_fdata.profit_contribution_employer = this.roundProfift(percentdata.employer_profit);
                        this.settlement_fdata.profit_contribution_employee = this.roundProfift(percentdata.employee_profit);
                        this.settlement_fdata.profit_contribution_employee_waived = this.roundProfift(percentdata.employee_profit_waived);
                        this.settlement_fdata.profit_contribution_employer_waived = this.roundProfift(percentdata.employer_profit_waived);

                        // End: Rejwan: 18-06-2025 Settlement

                    }.bind(this))
                    .catch(function (error)
                    {
                      this.showoverlay = false;
                      currentObj.serverError(error);
                    });
            },

            // Start: Rejwan: 18-06-2025 Settlement
            roundProfift(value)
            {
                var money = Number(String(value).replace(/,/g, ''));
                if(this.$atl_company_number_format.trim() == 'no')
                {
                    var money = Math.round(money);
                    return money;
                } else {
                    return money.toFixed(2);
                }
            },
            // End: Rejwan: 18-06-2025 Settlement

            // faroque code ends here

            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }

            //     return money;
            // },
            toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, '');
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return 0;
            },
            deregistrationSubmit(e)
            {
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let currentObj = this;
                let formData = new FormData();
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                     if (!result) {
                        return;
                    }

                    currentObj.showoverlaymodal = true;
                    if(this.settlement_fdata.id > 0)
                    {
                        var url = this.$api_url+'/pf/settlement-approval/update';
                    }
                    else if(this.settlement_fdata.id == 0)
                    {
                        var url = this.$api_url+'/pf/settlement/save';
                        this.settlement_fdata.employee_id = this.employee_id;
                        this.settlement_fdata.settlement_status	 = 0;
                        this.settlement_fdata.loan_adjustable = this.employee_pf_data.loan_adjustable;
                        this.settlement_fdata.service_charge_payable = this.employee_pf_data.service_charge_payable;
                        this.settlement_fdata.settlement_amount = this.settlement_amount;
                        this.settlement_fdata.settlement_reason = this.settlementreason;
                        this.settlement_fdata.adjustment_entries = JSON.stringify(this.adjustment_entries);


                        for (let [key, value] of Object.entries(this.settlement_fdata))
                        {
                            var nm = `${key}`;
                            var fval = `${value}`;
                            formData.append(nm, fval);
                        }

                        if(this.upload_file.length > 0)
                        {
                                this.upload_file.forEach(file => {
                                    formData.append("upload_file[]", file)
                                })
                        }
                    }

                    // Start: Rejwan: 18-06-2025 Settlement
                    let reconcilation_amount = 0;
                    if(this.settlement_fdata.salary_contribution_employer > this.employee_pf_data.pf_contribution_company) {
                        let diff = this.settlement_fdata.salary_contribution_employer - this.employee_pf_data.pf_contribution_company;
                        reconcilation_amount += Math.round(diff * 100) / 100;
                    }
                    if(this.settlement_fdata.salary_contribution_employee > this.employee_pf_data.pf_contribution_employee) {
                        let diff = this.settlement_fdata.salary_contribution_employee - this.employee_pf_data.pf_contribution_employee
                        reconcilation_amount += Math.round(diff * 100) / 100;
                    }
                    if(this.settlement_fdata.profit_contribution_employer > this.employee_pf_data.pf_profit_company) {
                        let diff = this.settlement_fdata.profit_contribution_employer - this.employee_pf_data.pf_profit_company
                        reconcilation_amount += Math.round(diff * 100) / 100;
                    }
                    if(this.settlement_fdata.profit_contribution_employee > this.employee_pf_data.pf_profit_employee) {
                        let diff = this.settlement_fdata.profit_contribution_employee - this.employee_pf_data.pf_profit_employee;
                        reconcilation_amount += Math.round(diff * 100) / 100;
                    }
                    if(this.settlement_fdata.forfeiture_contribution_employer > this.employee_pf_data.pf_forfeiture_company) {
                        let diff = this.settlement_fdata.forfeiture_contribution_employer - this.employee_pf_data.pf_forfeiture_company;
                        reconcilation_amount += Math.round(diff * 100) / 100;
                    }
                    if(this.settlement_fdata.forfeiture_contribution_employee > this.employee_pf_data.pf_forfeiture_employee) {
                        let diff = this.settlement_fdata.forfeiture_contribution_employee - this.employee_pf_data.pf_forfeiture_employee;
                        reconcilation_amount += Math.round(diff * 100) / 100;
                    }
                    formData.append('reconcilation_amount', reconcilation_amount);
                    // End: Rejwan: 18-06-2025 Settlement

                    axios.post(url,formData,config)
                    .then(function (response)
                    {
                        if(response.data.success){
                            currentObj.$bvToast.toast(response.data.message, {title: 'Success',variant: 'success',solid: true});

                        }else{
                            if(response.data.message){
                                currentObj.$bvToast.toast(response.data.message, {
                                    title: `Error`,
                                    variant: 'danger',
                                    solid: true
                                });
                            }else{
                                currentObj.$bvToast.toast("Application Submitted", {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                            }

                        }
                        currentObj.$bvModal.hide('bv-modal-process-settlement');
                        currentObj.showoverlaymodal = false;

                    }.bind(currentObj))
                    .catch(function (error)
                    {
                        //currentObj.errormsg = error.response.data.errors;

                        console.log(error);
                        currentObj.showoverlaymodal = false;

                    });



                });
                console.log(this.settlement_fdata);

            },
            processSettlement: function(employee_id)
            {

                let currentObj = this;
                currentObj.showoverlay = true;
                axios.get(this.$api_url+'/pf/employee/data' , {
                    params: {
								employee_id: employee_id,
							}

                }).then(function(response){
                    this.employee_pf_data = response.data;

                    this.$bvModal.show('bv-modal-process-settlement');
                    currentObj.showoverlay = false;

                    //this.settlement_fdata.loan = this.curr_emp_loan_total;

                    }.bind(this)).catch(function (error){
                    currentObj.showoverlay = false;
                    console.log(error)
                });


            },

            // Mustafijur added function
            getEmployeePfReport: function(employee_id)
            {
                if(employee_id>0){
                    var curr_obj = this;

                    let formData = new FormData();
                    formData.append('employee_id', employee_id);
                    formData.append('d_type', 'excel');
                    this.loader = true;

                    this.downloadBlobResponse(
                        axios.post(this.$api_url + '/pf/report/profile', formData, { responseType: 'blob' }),
                        'loader' // your loader key in this component
                    );
                }

            },

        },
        created: function(){

          this.getReasons();
          if(this.settlement_id == 0 && this.employee_id > 0)
          {
            this.processSettlement(this.employee_id);
            const today = new Date();
            const formattedDate = today.toISOString().split('T')[0];
            this.settlement_fdata.settlement_date = formattedDate;
          }
          else if(this.settlement_id > 0 && this.employee_id > 0)
          {
            setTimeout(() => {

                this.settlement_fdata = this.settlement_data;
                this.processSettlement(this.employee_id);
                console.log(this.settlement_fdata);

            }, 1000);

          }
        },
        computed:
        {
            onAmountChange()
            {
                if(this.settlement_id == 0)
                {

                    this.settlement_amount = 0;
                    this.settlement_amount += parseFloat(this.settlement_fdata.salary_contribution_employer);
                    this.settlement_amount += parseFloat(this.settlement_fdata.salary_contribution_employee);
                    this.settlement_amount += parseFloat(this.settlement_fdata.profit_contribution_employer);
                    this.settlement_amount += parseFloat(this.settlement_fdata.profit_contribution_employee);
                    this.settlement_amount += parseFloat(this.settlement_fdata.forfeiture_contribution_employer);
                    this.settlement_amount += parseFloat(this.settlement_fdata.forfeiture_contribution_employee);
                    this.settlement_amount -= parseFloat(this.employee_pf_data.loan_adjustable);
                    this.settlement_amount -= parseFloat(this.employee_pf_data.service_charge_payable);

                    this.adjustment_entries.forEach(element => {

                        if(element.value != '' && element.value != undefined)
                        {
                            this.settlement_amount -= parseFloat(element.value);
                        }


                    });

                    // if(this.settlement_amount < 0 || this.settlement_amount > this.employee_pf_data.closing_balance) // Rejwan: 18-06-2025 Settlement
                    if(this.settlement_amount < 0 || this.settlement_amount - 1 > this.employee_pf_data.closing_balance) // Rejwan: 18-06-2025 Settlement
                    {
                        this.pf_from_disable = true;
                    }
                    else
                    {
                        this.pf_from_disable = false;
                    }
                }


            },
            displayNetPayable() {
                if(this.$atl_company_number_format == 'no') {
                    var sumOfRounded = 
                        Math.round(this.employee_pf_data.pf_contribution_employee) +
                        Math.round(this.employee_pf_data.pf_contribution_company) +
                        Math.round(this.employee_pf_data.pf_profit_employee) +
                        Math.round(this.employee_pf_data.pf_profit_company) +
                        Math.round(this.employee_pf_data.pf_forfeiture_employee) +
                        Math.round(this.employee_pf_data.pf_forfeiture_company);

                    var original = Math.round(this.employee_pf_data.pf_net_payable_amount);
                    return sumOfRounded > original ? sumOfRounded : original;
                }
                return this.employee_pf_data.pf_net_payable_amount;
                
            },
        }
    }
</script>
<style scoped>

#bv-modal-process-settlement .form-control.is-valid {
	padding-right: .75rem !important;
    z-index: 1;
}

/* Start: Rejwan: 16-02-2025 */
.error-message {
    white-space: normal;
}
/* End: Rejwan: 16-02-2025 */
</style>
